const API_NEWS_FIELDS = [
    'translations.news_title',
    'translations.back',
    'translations.read_more',
    'translations.no_news_info'
];
export { API_NEWS_FIELDS };
